<template>
  <vs-table hover-flat v-if="callbackGroups && callbackGroups.length" :data="callbackGroups" class="table-configuration-inbound-callback-group-list">
    <template slot="thead">
      <vs-th v-text="$t('callback_group.table.no')"></vs-th>
      <vs-th v-text="$t('callback_group.table.callback_group_no')"></vs-th>
      <vs-th v-text="$t('callback_group.table.name')"></vs-th>
      <vs-th class="text-center" v-text="$t('ring_group.table.action')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('callback_group.table.no')"></vs-td>
        <vs-td :data-tr-title="$t('callback_group.table.callback_group_no')">
          <vs-input type="number" :placeholder="$t('callback_group.table.callback_group_no')" v-model="tr.group" class="w-full" v-if="tr.edit == true"/>
          <validation-error :model-error="tr.callbackGroupFormErrors.group"></validation-error>
          <badge-clipboard :text="tr.group" v-if="tr.edit == false"></badge-clipboard>
        </vs-td>
        <vs-td :data-tr-title="$t('callback_group.table.name')">
          <vs-input :placeholder="$t('callback_group.table.name')" v-model="tr.name" class="w-full" v-if="tr.edit == true"/>
          <validation-error :model-error="tr.callbackGroupFormErrors.name"></validation-error>
          <span v-if="tr.edit == false">{{ tr.name }}</span>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <template v-if="tr.edit == true">
              <save-button @click="$emit('customClickSave', indextr, tr.id)" :id="'updateConfigurationCallbackGroupsButton' + tr.id"></save-button>&nbsp;
              <cancel-button @click="$emit('customClickCancel', indextr, tr.id)"></cancel-button>
            </template>
            <template v-if="tr.edit == false">
              <edit-button @click="$emit('customClickEdit', indextr, tr.id)"></edit-button>&nbsp;
              <delete-button @click="$emit('customClickDelete', indextr, tr.id)"></delete-button>
            </template>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Configuration.Inbound.CallbackGroups.List',
  props: {
    callbackGroups: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">
  .table-configuration-inbound-callback-group-list {
    tr {
      th {
        &:nth-child(1) { width: 5%; }
        &:nth-child(2) { width: 20%; }
        &:nth-child(3) { width: 60%; }
        &:nth-child(4) { width: 15%; }
      }

      th,
      td {
        vertical-align: middle;
      }
    }
  }
</style>
